<div class="tree-container">
	@for (root of roots; track root) {
		<app-group-tree-item
			[isDisplayUser]="isDisplayUser"
			[group]="root"
			[roles]="roles"
			[cultures]="cultures"
			[expanded]="true"
			(groupDisplayed)="onGroupDisplayed($event)"
			(groupEdited)="onGroupEdited($event)"
			(itemReseted)="onGroupReseted($event)"
			(userDisplayed)="onUserDisplayed($event)"
			(userEdited)="onUserEdited($event)"
			(userReseted)="onUserReseted($event)"></app-group-tree-item>
	}
</div>
